/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/15/19
 * Time: 3:05 PM
 */
import React, {Component, createRef} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import QrReader from 'react-qr-reader'
import './ScanQR.css'
import Details from "./Details/Details";
import {Button as SementicBtn, Input} from "semantic-ui-react";
import {Col, Row} from "reactstrap";
import LabelInput from "../../../../components/Input/LabelInput/LabelInput";
import * as common from '../../../../const/Common/CommonFunc';
import Cookies from "js-cookie";
import axios from "../../../../axios/axios_visitortag";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import pass_icon from "../../../../assets/img/recept_checkin/pass.svg";
import apiConfig from "../../../../axios/axios_api_services";
import {withTranslation} from "react-i18next";

class App extends Component {
  state = {
    result: null,
    ref_code: ''
  };

  toggle = () => {
  };

  handleScan = data => {
    if (data) {
      this.sendToBackend(data);

    }
  };
  handleError = err => {
    console.error(err)
  };

  handleChange = name => event => {
    clearTimeout(this.timeout);

    let value = event.target.value;
    this.setState({
      [name]: value
    });

    if(value.trim().length > 10){
      this.timeout = setTimeout(()=>{
        this.sendToBackend(value)
      }, 1000);
    }
  };

  sendRef = () => {
    let {ref_code} = this.state;
    if(ref_code.trim() === ""){
      common.notifyMessage("Please enter REF CODE")
    }else{
      this.sendToBackend(ref_code)
    }
  };

  sendToBackend = (value) => {
    // let {ref_code} = this.state;
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    axios.get(apiConfig.CORPORATE_PRESHEDULED_MEETING_CREATE({corporateId:corporateId,refId:value}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          if(response.data.error_code === 710){
            common.warningAlert(response.data.message, 1);

            let cards_list = this.props.all_available_card;
            cards_list.push({
              key: response.data.card.cardId,
              text: response.data.card.passId,
              value: response.data.card.cardId,
              image: {avatar: true, src: pass_icon},
            });
            this.props.receptionAllAvailableCardHandler(cards_list);
            this.setState({
              result: {
                isCard: true,
                meeting_pass_no: response.data.card.cardId,
                content: response.data.visitor
              }
            })
          }else {
            this.setState({
              result: {
                isCard: false,
                content: response.data.content
              }
            })
          }

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })

      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend(value);
        }
      })
      .finally(fin =>{
        this.props.spinnerHandler(false);
      })
  };
  inputRefCode = createRef();
  // inputRef_code = createRef();
  componentDidMount() {
    this.inputRefCode.current.focus();
  }
  render() {
    const {t} = this.props;
    return (
      <div className={"qr-scan-modal-wrapper"}>
        {
          this.state.result === null ?
            <div isOpen={true} toggle={this.toggle} size="md" className={"qr-scan-modal"}>
              <MDBModalHeader className={"title"} toggle={this.props.closeModal}>{t('scan_qr_code')}</MDBModalHeader>

              <MDBModalBody style={{padding: '0px'}}>
                <Row className={"scan-qr-div"}>
                  <Col lg="8" md={"8"} sm={"8"} xs={"8"} className={"scan-qr-col8"}>
                    <Input
                      ref={this.inputRefCode}
                      focus={true}
                      // style={txtStyle}
                      className={"ref-qr-input"}
                      label={{tag: false, content: t('ref_code')}}
                      labelPosition='left'
                      placeholder={t('enter_ref_code')}
                      value={this.state.ref_code}
                      onChange={this.handleChange('ref_code')}
                    />
                  </Col>
                  <Col lg="4" md={"4"} sm={"4"} xs={"4"} className={"search-visitor-col"}>
                    <SementicBtn className="px-5 search-visitor-btn"
                                 onClick={this.sendRef}>{t('search')}</SementicBtn>
                  </Col>
                </Row>

                <QrReader
                  delay={300}
                  onError={this.handleError}
                  onScan={this.handleScan}
                  style={{width: '100%'}}
                />

              </MDBModalBody>
            </div>
            :
            <MDBModal isOpen={true} toggle={this.toggle} size="lg">
              <MDBModalHeader className={"title"} toggle={this.props.closeModal}>{t('meeting_details')}</MDBModalHeader>
              <MDBModalBody>
                <div>
                  <Details closeModal={this.props.closeModal} result={this.state.result}/>
                </div>
              </MDBModalBody>
            </MDBModal>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
